// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[class^='typo-'],
[class*=' typo-'] {
  font-family: 'Poppins';
}

:root {
  --typo-hero-v1-size: 72px;
  --typo-hero-v1-height: 108px;

  --typo-hero-v2-size: 56px;
  --typo-hero-v2-height: 84px;

  --typo-heading-v1-size: 48px;
  --typo-heading-v1-height: 72px;

  --typo-heading-v2-size: 32px;
  --typo-heading-v2-height: 48px;

  --typo-heading-v3-size: 24px;
  --typo-heading-v3-height: 36px;

  --typo-body-v1-size: 20px;
  --typo-body-v1-height: 40px;

  --typo-body-v2-size: 16px;
  --typo-body-v2-height: 32px;

  --typo-body-v3-size: 14px;
  --typo-body-v3-height: 28px;

  --typo-info-note-size: 12px;
  ---typo-info-note-height: 24px;
}

/* desktop or tablet typography */

.typo-hero-v1 {
  font-size: 72px;
  line-height: 108px;
}

.typo-hero-v2 {
  font-size: 56px;
  line-height: 84px;
}

.typo-heading-v1 {
  font-size: 48px;
  line-height: 72px;
}

.typo-heading-v2 {
  font-size: 32px;
  line-height: 48px;
}

.typo-heading-v3 {
  font-size: 24px;
  line-height: 36px;
}

.typo-body-v1 {
  font-size: 20px;
  line-height: 40px;
}

.typo-body-v2 {
  font-size: 16px;
  line-height: 32px;
}

.typo-body-v3 {
  font-size: 14px;
  line-height: 28px;
}

.typo-info-note {
  font-size: 12px;
  line-height: 24px;
}

/* mobile typography */

@media (max-width: 550px) {
  .typo-hero-v1 {
    font-size: 32px;
    line-height: 48px;
  }

  .typo-hero-v2 {
    font-size: 32px;
    line-height: 48px;
  }

  .typo-heading-v1 {
    font-size: 32px;
    line-height: 48px;
  }

  .typo-heading-v2 {
    font-size: 24px;
    line-height: 36px;
  }

  .typo-heading-v3 {
    font-size: 20px;
    line-height: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/typography.css"],"names":[],"mappings":"AAAA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;;EAE5B,yBAAyB;EACzB,2BAA2B;;EAE3B,4BAA4B;EAC5B,8BAA8B;;EAE9B,4BAA4B;EAC5B,8BAA8B;;EAE9B,4BAA4B;EAC5B,8BAA8B;;EAE9B,yBAAyB;EACzB,2BAA2B;;EAE3B,yBAAyB;EACzB,2BAA2B;;EAE3B,yBAAyB;EACzB,2BAA2B;;EAE3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA,iCAAiC;;AAEjC;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA,sBAAsB;;AAEtB;EACE;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":["[class^='typo-'],\n[class*=' typo-'] {\n  font-family: 'Poppins';\n}\n\n:root {\n  --typo-hero-v1-size: 72px;\n  --typo-hero-v1-height: 108px;\n\n  --typo-hero-v2-size: 56px;\n  --typo-hero-v2-height: 84px;\n\n  --typo-heading-v1-size: 48px;\n  --typo-heading-v1-height: 72px;\n\n  --typo-heading-v2-size: 32px;\n  --typo-heading-v2-height: 48px;\n\n  --typo-heading-v3-size: 24px;\n  --typo-heading-v3-height: 36px;\n\n  --typo-body-v1-size: 20px;\n  --typo-body-v1-height: 40px;\n\n  --typo-body-v2-size: 16px;\n  --typo-body-v2-height: 32px;\n\n  --typo-body-v3-size: 14px;\n  --typo-body-v3-height: 28px;\n\n  --typo-info-note-size: 12px;\n  ---typo-info-note-height: 24px;\n}\n\n/* desktop or tablet typography */\n\n.typo-hero-v1 {\n  font-size: 72px;\n  line-height: 108px;\n}\n\n.typo-hero-v2 {\n  font-size: 56px;\n  line-height: 84px;\n}\n\n.typo-heading-v1 {\n  font-size: 48px;\n  line-height: 72px;\n}\n\n.typo-heading-v2 {\n  font-size: 32px;\n  line-height: 48px;\n}\n\n.typo-heading-v3 {\n  font-size: 24px;\n  line-height: 36px;\n}\n\n.typo-body-v1 {\n  font-size: 20px;\n  line-height: 40px;\n}\n\n.typo-body-v2 {\n  font-size: 16px;\n  line-height: 32px;\n}\n\n.typo-body-v3 {\n  font-size: 14px;\n  line-height: 28px;\n}\n\n.typo-info-note {\n  font-size: 12px;\n  line-height: 24px;\n}\n\n/* mobile typography */\n\n@media (max-width: 550px) {\n  .typo-hero-v1 {\n    font-size: 32px;\n    line-height: 48px;\n  }\n\n  .typo-hero-v2 {\n    font-size: 32px;\n    line-height: 48px;\n  }\n\n  .typo-heading-v1 {\n    font-size: 32px;\n    line-height: 48px;\n  }\n\n  .typo-heading-v2 {\n    font-size: 24px;\n    line-height: 36px;\n  }\n\n  .typo-heading-v3 {\n    font-size: 20px;\n    line-height: 40px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
